// Dependencies
require("section/avantages");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/avantages/index.js
 ** module id = 125
 ** module chunks = 0 1
 **/